import { render, staticRenderFns } from "./ResourceTextEditor.vue?vue&type=template&id=0890e6b4"
import script from "./ResourceTextEditor.vue?vue&type=script&lang=js"
export * from "./ResourceTextEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports